import React from 'react';
import './ScenarioInfo.css';
import ChangeScenarioButton from './ChangeScenarioButton';

export const scenarioLabels = {
  case1: 'Commercial High-Resolution Tasking',
  case2: 'Large Constellation Revisit',
};

export const getScenarioLabel = (scenario) => scenarioLabels[scenario] || scenario;

function ScenarioInfo({ scenario, toggleScenario }) {
  const customValue = getScenarioLabel(scenario);

  return (
    <div className="scenario-info-box">
      <p>Scenario: {customValue}</p>
      <ChangeScenarioButton toggleScenario={toggleScenario}/>
    </div>
  );
}

export default ScenarioInfo;
